import {Checkbox, FormControlLabel, Box, Typography} from '@mui/material';

export interface TopicSelectionHeaderProps {
  showSelectAll: boolean;
  isAllSelected: boolean;
  isIndeterminate: boolean;
  disabled?: boolean;
  onToggleAll: () => void;
}

export default function TopicSelectionHeader({
  showSelectAll,
  isAllSelected,
  isIndeterminate,
  disabled = false,
  onToggleAll,
}: TopicSelectionHeaderProps) {
  if (!showSelectAll) return null;

  return (
    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1}}>
      <Typography variant="subtitle2">Select Topics</Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={isAllSelected}
            indeterminate={isIndeterminate}
            onChange={onToggleAll}
            size="small"
            disabled={disabled}
          />
        }
        label="All"
        sx={{'& .MuiFormControlLabel-label': {fontSize: '0.875rem'}}}
      />
    </Box>
  );
}
